import { Badge, Button, Col, Drawer, Row } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { IEstoqueCart } from '../../../../store/ducks/estoqueCart/types';
import { clearCart, deleteItemRequest } from '../../../../store/ducks/estoqueCart/actions';
import { RollbackOutlined, ProfileOutlined } from '@ant-design/icons';

import {
  BadgeAdd,
  BadgeCar,
  Container,
  DeleteItemIcon,
  Div,
  FontSize,
  NameStrong,
  Spacement,
  TitleContainer,
} from './styles';
import { maskUndInt } from '../../../../utils/mask';
import { useWindowSize } from '../../../../hook/useWindowSize';
import history from '../../../../utils/history';

const DrawerEstoque: React.FC<any> = ({ type }) => {
  const estoqueCart = useSelector((state: ApplicationState) => state.EstoqueCart);
  const [visible, setVisible] = useState(false);
  const { width }: any = useWindowSize();
  const dispatch = useDispatch<Dispatch<Action>>();

  useEffect(() => {
    if (estoqueCart.cart.length === 0) setVisible(false);
  }, [estoqueCart.cart.length]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const deleteItem = (i: IEstoqueCart, qtdT: string) => {
    const index = estoqueCart.cart.findIndex(
      ({ codProduto, controle }) => codProduto === i.codProduto && controle === i.controle
    );
    const newEstoque = estoqueCart.cart;
    newEstoque[index] = { ...i, [`${qtdT}`]: undefined };
    if (!newEstoque[index]?.quantidade) {
      newEstoque.splice(index, 1);
    }
    dispatch(deleteItemRequest(newEstoque));
    if (estoqueCart.cart.length === 0) dispatch(clearCart());
  };

  return (
    <>
      <Spacement>
        <>
          {width >= 768 ? (
            estoqueCart.cart.length === 0 && type === 'header' ? undefined : (
              <Button type="text" size="middle" onClick={showDrawer}>
                {estoqueCart.cart.length === 0 && type === 'header' ? undefined : type ===
                  'header' ? (
                  <ProfileOutlined style={{ fontSize: 20 }} />
                ) : (
                  <>
                    <RollbackOutlined /> Lista de retorno de mercadoria
                  </>
                )}
                <BadgeAdd>
                  <Badge
                    className="site-badge-count-109"
                    size="small"
                    count={estoqueCart.cart.length > 0 ? estoqueCart.cart.length : 0}
                    style={{ backgroundColor: '#52c41a', color: '#fff' }}
                  />
                </BadgeAdd>
              </Button>
            )
          ) : estoqueCart.cart.length === 0 && type === 'header' ? undefined : (
            <Button type="text" size="middle" onClick={showDrawer}>
              {estoqueCart.cart.length === 0 && type === 'header' ? undefined : type ===
                'header' ? (
                <ProfileOutlined style={{ fontSize: 20 }} />
              ) : (
                <>
                  <ProfileOutlined style={{ fontSize: 20 }} />
                </>
              )}
              <BadgeAdd>
                <Badge
                  className="site-badge-count-109"
                  size="small"
                  count={estoqueCart.cart.length > 0 ? estoqueCart.cart.length : 0}
                  style={{ backgroundColor: '#52c41a', color: '#fff' }}
                />
              </BadgeAdd>
            </Button>
          )}
        </>
      </Spacement>

      <Drawer
        closeIcon={<RollbackOutlined />}
        title={
          <TitleContainer>
            <FontSize>
              <Div>
                <Row gutter={24}>
                  <Col md={24} sm={24} xs={24}>
                    <RollbackOutlined /> Lista de mercadoria
                    <ProfileOutlined style={{ fontSize: 20, marginLeft: 15 }} />
                    <BadgeCar>
                      <Badge
                        className="site-badge-count-109"
                        size="small"
                        count={estoqueCart.cart.length > 0 ? estoqueCart.cart.length : 0}
                        style={{ backgroundColor: '#52c41a', color: '#fff' }}
                      />
                    </BadgeCar>
                  </Col>
                </Row>
              </Div>
            </FontSize>
          </TitleContainer>
        }
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width={350}
      >
        {estoqueCart?.cart?.map((drwer) => (
          <>
            <Container>
              {drwer?.quantidade && (
                <>
                  <Div>
                    Nota: <NameStrong>{drwer.numNota}</NameStrong>
                  </Div>
                  <Div>
                    Lote: <NameStrong>{drwer.controle}</NameStrong>
                  </Div>
                  <NameStrong>{drwer.descricaoProduto}</NameStrong>

                  <TitleContainer>{drwer.nomePagador}</TitleContainer>

                  <NameStrong>
                    {`QTD: ${maskUndInt(drwer.quantidade * drwer.qtdPadraoFracionado)} ${
                      drwer.siglaUnidade
                    }`}
                    <DeleteItemIcon
                      className="deleteCart"
                      onClick={() => deleteItem(drwer, 'quantidade')}
                    />
                  </NameStrong>
                </>
              )}
            </Container>
          </>
        ))}

        <Button
          hidden={!estoqueCart.cart.length}
          size="middle"
          type="primary"
          htmlType="submit"
          onClick={() => {
            history.push('/dashboard/confirmRetorno');
            setVisible(false);
          }}
          block
        >
          Continuar
        </Button>
      </Drawer>
    </>
  );
};

export default DrawerEstoque;
